import { createSlice } from "@reduxjs/toolkit";
import { getEnrollmentAPI } from "../../../services/guestUsers/guestUserAllAPIService";
const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const getEnrollmentSlice = createSlice({
  name: "getEnrollment",
  initialState: data,
  reducers: {
    getEnrollmentSliceInfo(state) {
      state.isLoading = true;
    },
    getEnrollmentSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    getEnrollmentSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    getEnrollmentSliceReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const getEnrollmentHandler = (data) => async (dispatch) => {
  try {
    dispatch(getEnrollmentSliceAction.getEnrollmentSliceInfo());
    const response = await getEnrollmentAPI(data);
    dispatch(getEnrollmentSliceAction.getEnrollmentSliceSuccess(response));
  } catch (e) {
    dispatch(getEnrollmentSliceAction.getEnrollmentSliceFailure(e));
  }
};
export default getEnrollmentSlice.reducer;
export const getEnrollmentSliceAction = getEnrollmentSlice.actions;
